<template>
   <div class="files-wrapper">
    <ul class="summary_items">
      <li
        v-for="(item,index) in conversationSummary"
        :key="index"
        class="summary_item mb_20"
      >
        <p>{{item.summary}}</p>
      </li>
    </ul>

    <div v-if="!conversationSummary.length" class="no-label-message">
      <span>
        {{ $t('CONTACT_PANEL.CONVERSATION_SUMMARY.NO_RECORDS_FOUND') }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
    conversationId: {
      type: [String, Number],
      required: true,
    },
  },
  data(){
    return {}
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      conversationSummary:"getConversationSummary",
    }),
  },
  mounted(){
    this.$store.dispatch('fetchConversationSummary', {
      conversationId: this.conversationId,
    });
  },
  watch: {
    conversationId(newVal, oldVal) {
      this.$store.dispatch('fetchConversationSummary', {
        conversationId: newVal,
      });
    }
  },
  methods:{
    // async downloadFile(file) {
    //   // Implement download logic here
    //   if (!file || !file.url) {
    //     console.warn("No file or URL to download");
    //     return;
    //   }

    //   // Use the file name or fallback
    //   const filename = file.filename || 'download';

    //   // Create a temporary anchor element
    //   const link = document.createElement('a');
    //   link.href = file.url;
    //   link.target = '_blank';

    //   // Set the download attribute to suggest filename
    //   link.setAttribute('download', filename);

    //   // Some browsers require the link to be in the DOM
    //   document.body.appendChild(link);

    //   // Trigger the download
    //   link.click();

    //   // Clean up
    //   document.body.removeChild(link);
    // },
    // methods end
  },

}
</script>


<style lang="scss" scoped>
.summary_items{

}
.summary_item{

}

.no-label-message {
  margin-bottom: var(--space-normal);
  color: var(--b-500);
}

</style>